/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Failed_Events_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Failed Events List" |
*
* @param {Style_Guide_Failed_Events_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_failed_events_aria_label = /** @type {((inputs?: Style_Guide_Failed_Events_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Failed_Events_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste des evenements echoues")
	if (locale === "de") return /** @type {LocalizedString} */ ("Liste der fehlgeschlagenen Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elenco eventi non riusciti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Список неудачных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lista de eventos fallidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("失败事件列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("失敗したイベントリスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असफल घटनाओं की सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lista de eventos com falha")
	return /** @type {LocalizedString} */ ("Failed Events List")
});